import React from 'react'
import _ from 'lodash/fp'

const PRIMARY_EVIDENCE = ({extension}) => extension.toLowerCase() === "vmu"

const WHITE_LIST = ['vmu','jpeg','jpg','opt']

const FILTER_GROUP = (primaryFile,compatible) => {
  const miraxRoot = primaryFile.path
  return compatible.path === miraxRoot
}

const VALIDATE = (group) => {
  const images = group.filter(({extension}) => ['jpeg','jpg'].indexOf(extension.toLowerCase()))
  return images.length>0
}

export const HamamatsuVMUParserConfig = {PRIMARY_EVIDENCE,WHITE_LIST,FILTER_GROUP,VALIDATE}